import classNames from 'classnames';
import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import Typography from '@libs/ui/components/typography';

import useStyles from './styles';

export interface StepSectionProps {
  children?: React.ReactNode;
  index: number | string;
  title: string;
  className?: string;
}

const StepSection = (props: StepSectionProps) => {
  const { children, index, title, className } = props;
  const classes = useStyles(props);

  return (
    <Box className={classNames(classes.stepContainer, className)}>
      <Grid alignContent="center" alignItems="center" container>
        <Grid item>
          <i className={classes.index}>{index}</i>
        </Grid>
        <Grid item>
          <Typography>{title}</Typography>
        </Grid>
      </Grid>
      <Box className={classes.content}>{children}</Box>
    </Box>
  );
};

export default StepSection;
